import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormInput } from './campo';

const PasswordInput = ({ id, name, placeholder, onChange, value, isDisabled, isReadOnly }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="position-relative w-100">
      <FormInput
        id={id}
        type={showPassword ? 'text' : 'password'}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
      />
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="material-icons eye-toggle"
        aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        style={{ zIndex: 10, background: 'transparent', border: 'none', padding: 0 }}
      >
        {showPassword ? 'visibility_off' : 'visibility'}
      </button>
    </div>
  );
};

PasswordInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isReadOnly: PropTypes.bool,
};

export default PasswordInput;
